export const ARCADE_TYPES = {
  BRAND: 'Brand',
  BRAND_DARK: 'Brand Dark',
  PROMINENT: 'Prominent',
  PROMINENT_DARK: 'Prominent Dark',
  STANDARD: 'Standard',
  STANDARD_DARK: 'Standard Dark',
  SUBTLE: 'Subtle',
  SUBTLE_DARK: 'Subtle Dark',
  EXTRASUBTLE: 'Extra Subtle',
  EXTRASUBTLE_DARK: 'Extra Subtle Dark',
  INVERSE: 'Inverse',
  INVERSE_DARK: 'Inverse Dark',
  DISABLED: 'Disabled',
  DISABLED_DARK: 'Disabled Dark',
  DANGER: 'Danger',
  DANGER_DARK: 'Danger Dark',
  WARNING: 'Warning',
  WARNING_DARK: 'Warning Dark',
  SUCCESS: 'Success',
  SUCCESS_DARK: 'Success Dark',
  INFO: 'Info',
  INFO_DARK: 'Info Dark',
} as const
